import {Component, Input} from '@angular/core';

@Component({
    selector: 'tab-item-property',
    templateUrl: './tab-item-property.component.html',
    styleUrls: ['./tab-item-property.component.scss']
})
export class TabItemPropertyComponent {
    @Input() title: string;
    @Input() active = false;
    @Input() id: string;
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/tabs/tab-item/tab-item-property.component.ts